import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

class PreferencesCustomCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.field.defaultValue,
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEmpty(nextProps.userPreference)) {
      const keys = this.props.field.dbKey.split('.');
      this.setState({ isChecked: nextProps.userPreference[keys[0]][keys[1]] });
    }
  }

  onValueChange = () => {
    this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }), () => this.props.updatePreferences(this.props.field.dbKey, this.state.isChecked));
  }

  render() {
    const { field } = this.props;
    const { isChecked } = this.state;
    return (
      <div className="custom-preference">
        <div className="custom-preference-content">
          <input id={field.dbKey} type="checkbox" onChange={() => this.onValueChange()} checked={isChecked} />
          <label htmlFor={field.dbKey}>{field.inputLabel}</label>
        </div>
      </div>
    );
  }
}

PreferencesCustomCheckbox.propTypes = {
  field: PropTypes.shape({
    defaultValue: PropTypes.bool,
    dbKey: PropTypes.string,
    inputLabel: PropTypes.string,
  }),
  updatePreferences: PropTypes.func,
  userPreference: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    userPreference: state.preferences.userPreferences,
  };
}

export default connect(mapStateToProps)(PreferencesCustomCheckbox);
